module.exports = __webpack_public_path__ + "img/Dotkit-RemoveNearest.61e587f7.jpg";